/* eslint-disable react-hooks/exhaustive-deps */
import { Steps } from 'antd';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router';
// import Confirmacion from '../../components/cotizar/confirmacion';
import DatosUsuario from '../../components/cotizar/datosUsuario';
import Flota from '../../components/cotizar/flota';
import Generico from '../../components/cotizar/generico';
import Mantencion from '../../components/cotizar/mantencion';
import Mercado from '../../components/cotizar/mercado';
import Producto from '../../components/cotizar/producto';
import Repuesto from '../../components/cotizar/repuesto';
import Vehiculo from '../../components/cotizar/vehiculo';
import Footer from '../../components/foter/footer';
import Navbar from '../../components/navbar/navbar';
import Seo from '../../components/seo/seo';
import queryString from 'query-string';
import leftIcon from "../../../img/slider/left.svg";

import './index.css'
import '../../../css/global.css';

const { Step } = Steps;

const Cotizar = () => {
    const { seccion, slug } = useParams();
    const query = queryString.parse(window.location.search.substring(1));
    const [queryURL, setQueryURL] = useState(query);
    const [formProducto, setFormP] = useState(undefined);
    const [formUsuario, setFormU] = useState(undefined);
    const [component, setComp] = useState(undefined);
    const [producto, setProducto] = useState(undefined);
    const [showFooter, setShowFooter ] = useState(true);
    const datosForms = { formProducto, formUsuario };
    const [paso, setPaso] = useState(0);

    const pasoSig = () => {
        setPaso(paso + 1);
    }

    const pasoAnt = () => {
        setPaso(paso - 1);
    }

    const cambiarPaso = () => {
        if (paso === 1) {
            setPaso(0);
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        //OCULTAR FOOTER EN COTIZAR
        const url = window.location.href;
        const media = window.matchMedia("(max-width: 767px)");

        if(url.includes("cotizar") && media.matches){
            setShowFooter(false);
        } else {
            setShowFooter(true); 
        }

    }, [paso])


    useEffect(() => {
        try {
            if(window && window.visitData && Object.keys(queryURL).length === 0){
                const visit = window.visitData.get();
                setQueryURL({ utm_source: visit.source && visit.source !== '(direct)' ? (visit.source === 'organic' ? 'organico' : visit.source) : '', 
                                utm_medium: visit.medium && visit.medium !== '(none)' ? (visit.medium === 'google' ? 'goole_search' : visit.medium) : '' })
            }            
        } catch (error) {
            console.log('Error visit source: ', error)
        }

    }, [])

    const statesProducto = { setPaso, setFormP, setProducto, setFormU, formProducto, queryURL, producto };

    useEffect(() => {
        if (seccion) {
            let seccionLC = seccion.toLowerCase();
            if (seccionLC === 'mercado-publico') {
                setComp(<Mercado states={statesProducto} />)
                return;
            }
            if (seccionLC === 'vehiculo') {
                setComp(<Vehiculo states={statesProducto} />)
                return;
            }
            if (seccionLC === 'flotas') {
                setComp(<Flota states={statesProducto} />);
                return;
            }
            if (seccionLC === 'repuesto') {
                setComp(<Repuesto states={statesProducto} />);
                return;
            }
            if (seccionLC === 'mantencion') {
                setComp(<Mantencion states={statesProducto} />);
                return;
            }
            else {
                setComp(<Generico states={statesProducto} />)
            }
        }
        else
            if (!seccion)
                setComp(<Generico states={statesProducto} />);
    }, [seccion, formProducto])

    const getViewPortWidth = () => {
        let viewportwidth;
        // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
        if (typeof window.innerWidth != 'undefined') {
            viewportwidth = window.innerWidth;
            // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
        } else
            if (typeof document.documentElement != 'undefined' &&
                typeof document.documentElement.clientWidth != 'undefined' &&
                document.documentElement.clientWidth != 0) {
                viewportwidth = document.documentElement.clientWidth;
                // older versions of IE
            } else {
                viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
            }
        return viewportwidth;
    }

    const pasos = [
        {
            title: <h5 className="bold-text-hyundai f-18 ml-2 mb-0 f-responsive-1">Paso 1</h5>,
            desc: <p className={`cotizar-subtitle parrafo-hyundai ml-2 font-c f-responsive-10`}>{'Selecciona el producto '}</p>,
            content: component
        },
        {
            title: <h5 className="bold-text-hyundai f-18 ml-2 mb-0 f-responsive-1">Paso 2</h5>,
            desc: <p className={`cotizar-subtitle parrafo-hyundai ml-2 font-c f-responsive-10`}>{'Ingresa tus datos'}</p>,
            content: <DatosUsuario states={statesProducto} userData={formUsuario} producto={producto} datosForms={datosForms} />
        }
        // {
        //     title: <h5 className="bold-text-hyundai f-18 ml-2 mb-0 f-responsive-1">Paso 3</h5>,
        //     desc: <p className={`cotizar-subtitle parrafo-hyundai ml-2 font-c f-responsive-10`}>{'Confirmación envío de cotización'}</p>,
        //     content: <Confirmacion producto={producto} states={statesProducto} datosForms={datosForms} />
        // }
    ];

    const pasosMobile = [
        {
            title: <h5 className="bold-text-hyundai f-18 ml-0 mb-0 mt-2 f-responsive-1">Producto</h5>,
            content: component
        },
        {
            title: <h5 className="bold-text-hyundai f-18 ml-0 mb-0 mt-2 f-responsive-1">Datos de contacto</h5>,
            content: <DatosUsuario states={statesProducto} userData={formUsuario} producto={producto} datosForms={datosForms} />
        }
    ];

    const sizes = producto ? { xs: 12, md: 5, xl: 6 } : { xs: 12, md: 10, lg: 8, xl: 5 };

    return (
        <>
            <Navbar />
            <Seo title="Cotizar -" />
            <main >
                <Container fluid className="bg-cotizar px-2">
                    <Row className='row-formulario-cotizar mx-md-0'>
                        <Col
                            xs={12}
                            md={11}
                            lg={10}
                            xl={8}
                            className="col-formulario-cotizar mx-auto mb-general mt-md-5 bg-white px-0"
                        >
                            {/* comienzo del steps */}
                            
                            <img src={leftIcon} className="img-back d-md-none" alt='' onClick={cambiarPaso} />
                            <Steps
                                className="steps-cotizar-hyundai mt-2 pl-5 pl-md-0 pr-2 pr-md-0"
                                current={paso}
                                type="navigation"
                                size='small'
                                // onChange={cambiarPaso}
                            >
                                
                                {
                                    getViewPortWidth() > 768 ? 
                                        pasos.map((paso, i) =>
                                            <Step key={i} title={paso.title} description={paso.desc}></Step>
                                        )
                                    :                                        
                                        pasosMobile.map((paso, i) =>
                                            <Step key={i} title={paso.title} description={paso.desc}></Step>
                                        )
                                    
                                }
                            </Steps>
                            <Container fluid >
                                <Row className="mx-0">
                                    {producto &&
                                        <Col
                                            xs={12}
                                            md={12}
                                            lg={6}
                                            className="mx-auto mt-md-5 bg-white py-2 px-0"
                                            style={{ marginTop: '1rem' }}
                                        >
                                            <Producto producto={producto} />
                                        </Col>
                                    }
                                    {
                                        producto ? (
                                            <Col  {...sizes} className="mx-auto mt-md-5 px-0">
                                                {producto &&
                                                    <div className="paraFixedMobile"></div>
                                                }
                                                {pasos[paso].content}
                                            </Col>
                                        ) : 
                                            <Col  {...sizes} className="mx-auto mt-md-5 px-0" style={{ marginTop: '1rem' }}>
                                                {producto &&
                                                    <div className="paraFixedMobile"></div>
                                                }
                                                {pasos[paso].content}
                                            </Col>
                                    }
                                </Row>
                            </Container>
                            {/* termino del steps */}
                        </Col>
                        {/* {
                            getViewPortWidth() <= 768 &&
                            <Col
                                xs={12}
                                md={11}
                                lg={10}
                                xl={8}
                                className="col-btn-formulario-cotizar mx-auto mb-md-3"
                            >
                                <Row className='d-flex justify-content-center'>
                                    <Col
                                        xs={12}
                                        md={10}
                                        lg={7}
                                        xl={4}
                                    >
                                        <Button
                                            className="btn-primario-cotizador font-btn w-100 f-responsive mb-5"
                                            onClick={pasoSig}
                                        >
                                            Siguiente
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        } */}
                    </Row>
                </Container>
            </main>

            
            {showFooter ? <Footer /> : <></>}
        </>
    );
}

export default Cotizar;

//mantencion sin precio
// vehiculo con precio
// mp con precio
//flotas sin precio
//repuestos sin precio